module.exports = __webpack_public_path__ + "media/images/top-design-01-9409ad90cb05830319ef62389a143f10.jpg";